import { 
    GET_EMPLOYEE_REPORT_DETAILED_TABLE_FAILURE,
    GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST,
    GET_EMPLOYEE_REPORT_DETAILED_TABLE_SUCCESS,
    GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_FAILURE, 
    GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST, 
    GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_SUCCESS 
} from "./salesEmployeeTabSliceConstants";

export const employeeReportDropDownFilterRequest = (data) => {
    return {
        type: GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST,
        payload: data
    }
}

export const employeeReportDropDownFilterSuccess = (data) => {
    return {
        type: GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_SUCCESS,
        payload: data
    }
}

export const employeeReportDropDownFilterFailure = (error) => {
    return {
        type: GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_FAILURE,
        payload: error
    }
}

export const employeeReportDetailedTableRequest = (data) => {
    return {
        type: GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST,
        payload: data
    }
}

export const employeeReportDetailedTableSuccess = (data) => {
    return {
        type: GET_EMPLOYEE_REPORT_DETAILED_TABLE_SUCCESS,
        payload: data
    }
}

export const employeeReportDetailedTableFailure = (error) => {
    return {
        type: GET_EMPLOYEE_REPORT_DETAILED_TABLE_FAILURE,
        payload: error
    }
}